export default __webpack_public_path__ + "static/media/footerLogo.5e1ad839.png";